import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reverse'
})
export class ReverseRenderingListPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value?.slice().reverse();
  }
}
